import { render } from "./Video.vue?vue&type=template&id=c29e87a4&scoped=true"
import script from "./Video.vue?vue&type=script&setup=true&lang=js"
export * from "./Video.vue?vue&type=script&setup=true&lang=js"

import "./Video.vue?vue&type=style&index=0&id=c29e87a4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c29e87a4"],['__file',"src/components/Questionnaire/Question/Video.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c29e87a4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c29e87a4', __exports__)) {
    api.reload('c29e87a4', __exports__)
  }
  
  module.hot.accept("./Video.vue?vue&type=template&id=c29e87a4&scoped=true", () => {
    api.rerender('c29e87a4', render)
  })

}


export default __exports__